import React, { use, useEffect, useRef, useState } from "react";
import { RouterProvider } from "react-router-dom";
import "../node_modules/bootstrap/dist/css/bootstrap.min.css";
import "./App.css";
import "../src/components/uikit/components/Snackbar/Snackbar.css";
import { ThemeProvider, createTheme } from "@mui/material";
import IdleTimer from "react-idle-timer";
import Cookies from "js-cookie";
// import { useCookies } from "react-cookie";
import router from "./routes/Routes";
// import { azure } from "./services/api/azure/apiService.js";
import { useDispatch, useSelector } from "react-redux";
import {
  setRefreshToken,
  setRefreshTokenExp,
  setToken,
  setUserID,
  setUserLoginEmail,
  setUserLoginName,
} from "./features/currentUser/currentUserSlice.js";
import { clarityNav } from "./services/api/clarityNav/apiService.js";
import {
  fetchLookupFailure,
  fetchLookupSuccess,
} from "./features/Lookup/lookupSlice.js";
import { setUsers } from "./features/product/projectSlice.js";
// import { sso } from "./services/api/sso/apiService.js";

// Custom Material-UI theme configuration
const theme = createTheme({
  palette: {
    primary: {
      main: "#4F46E5",
    },
    secondary: {
      main: "#00CA9F",
    },
    teritory: {
      main: "#EBEBFF",
    },
    success: {
      main: "#439771",
    },
    error: {
      main: "#F44E4E",
    },
  },
  typography: {
    fontFamily: "Montserrat",
    fontSize: 14,
    fontWeightRegular: 400,
    fontWeightMedium: 500,
    fontWeightBold: 600,
    subtitle1: {
      fontSize: 16,
    },
    button: {
      textTransform: "none",
      "& .iconButtonStyle": {
        minWidth: "none !important",
      },
    },
  },
});
function App() {
  // const [cookies, setCookie, removeCookie] = useCookies(["inizionavigator"]);
  // const token = cookies?.inizionavigator?.token;
  // dispatch hook
  const dispatch = useDispatch();
  // Reference for idle timer to detect user inactivity
  const idleTimerRef = useRef(null);
  // Function to handle user inactivity
  const onIdle = () => {
    Cookies.remove("inizionavigator"); // Remove user session cookie on inactivity
  };
  const currentuser = useSelector((state) => state?.currentUserDetail);
  const userInfo = useSelector((state) => state?.product?.users ?? "");
  // Azure API hooks for token validation, refresh, and logout operations
  // const [tokenValidationFunction] = azure.useTokenValidationMutation();
  // const [refreshApiCallFunction] = azure.useRefreshTokenFunMutation();
  // const [logoutApp] = azure.useLogoutApplicationMutation();
  const [fetchlookupData] = clarityNav.endpoints.getlookupdata.useLazyQuery();
  const [triggerGetUsersList, { data: userResponse }] =clarityNav.useGetUsersListMutation();
  const [getUserDetails] = clarityNav.useGetUserDetailsMutation();

  function getUserIdByEmail(userLoginEmail,userInfoArray) {
    if (!Array.isArray(userInfoArray) || !userLoginEmail) {
      return null;
    }

    const user = userInfoArray.find((user) => user?.email === userLoginEmail);

    return user ?? user?.user_id ;
  }
  // const currentUserId = getUserIdByEmail(currentuser?.userLoginEmail);
  // dispatch(setUserID(currentUserId));
  useEffect(() => {
    if (userInfo?.length === 0) {
      triggerGetUsersList({});
    }
  }, []);

  // useEffect(() => {
  //   if (Array.isArray(userResponse)) {
  //     dispatch(setUsers(userResponse));
  //     if (currentuser?.userLoginEmail) {
  //       const currentUserId = getUserIdByEmail(currentuser?.userLoginEmail,userResponse);
  //       dispatch(setUserID(currentUserId));
  //     }
      
  //   }
    
  // }, [currentuser?.userLoginEmail, userResponse]);

  // useEffect(() => {
  //   if (currentuser?.userLoginEmail) {
  //     const currentUserId = getUserIdByEmail(currentuser?.userLoginEmail);
  //     dispatch(setUserID(currentUserId));
  //   }
  // }, [currentuser?.userLoginEmail, userResponse]);
  
  // useEffect hook for set redux state(currentUserDetail) from cookies
  // useEffect(() => {
  //   if (cookies?.inizionavigator) {
  //     dispatch(setUserLoginEmail(cookies?.inizionavigator?.userLoginEmail));
  //     dispatch(setUserLoginName(cookies?.inizionavigator?.userLoginName));
  //     dispatch(setRefreshToken(cookies?.inizionavigator?.refreshToken));
  //     dispatch(setRefreshTokenExp(cookies?.inizionavigator?.refreshTokenExp));
  //     dispatch(setToken(cookies?.inizionavigator?.token));
  //   }
  // }, [cookies?.inizionavigator, cookies]);
  // fetch lookup and set in redux
  useEffect(() => {
    const getLookupData = async () => {
      try {
        const response = await fetchlookupData();
        dispatch(fetchLookupSuccess(response?.data?.result));
      } catch (error) {
        dispatch(
          fetchLookupFailure(error?.message || "Failed to fetch lookup data")
        );
      }
    };
    const getUserDetailsFunc = async () => {
      try {
        const response = await getUserDetails().unwrap();
        dispatch(setUserLoginEmail(response?.email));
        dispatch(setUserLoginName(response?.name));
        dispatch(setUserID(response?.user_id));

      } catch (error) {

      }
    }

    getLookupData();
    getUserDetailsFunc();
  }, []);

  // Token validation on component mount or cookie change
  // useEffect(() => {
  //   const validateToken = async () => {
  //     try {
  //       if (token) {
  //         const response = await tokenValidationFunction(token).unwrap();
  //         if (!response?.is_success) {
  //           window.location.href = process.env.REACT_APP_LOGIN_URL; // Redirect to login if token invalid
  //         }
  //       }
  //     } catch (error) {
  //       window.location.href = process.env.REACT_APP_LOGIN_URL; // Redirect on validation error
  //     }
  //   };
  //   if (!cookies) {
  //     window.location.href = process.env.REACT_APP_LOGIN_URL; // Redirect if no cookies
  //   }
  //   if (token) {
  //     validateToken();
  //   } else {
  //     window.location.href = process.env.REACT_APP_LOGIN_URL; // Redirect if no token
  //   }
  // }, [cookies?.inizionavigator?.exp]);

  // // // // Re
  // useEffect(() => {
  //   if (cookies?.inizionavigator?.refreshToken) {
  //     const tokenExpiry = cookies?.inizionavigator?.exp;
  //     const currentTime = Date.now();

  //     const timeDifference = tokenExpiry * 1000 - currentTime - 3 * 60 * 1000;
  //     setTimeout(() => {
  //       (async () => {
  //         try {
  //           const refreshToken = cookies?.inizionavigator?.refreshToken;

  //           const response = await refreshApiCallFunction(
  //             refreshToken
  //           ).unwrap();

  //           if (response?.is_success === true) {
  //             setCookie(`inizionavigator`, response?.responseCode, {
  //               path: "/",
  //               domain: process.env.REACT_APP_COOKIE_DOMAIN,
  //             }); // Update cookie with new token
  //           } else {
  //             // Logout and clear cookies on refresh failure
  //             await logoutApp();
  //             removeCookie(`inizionavigator`, {
  //               path: "/",
  //               domain: process.env.REACT_APP_COOKIE_DOMAIN,
  //             });
  //             window.location.href = process.env.REACT_APP_LOGIN_URL;
  //           }
  //         } catch (error) {
  //           await logoutApp();
  //           removeCookie(`inizionavigator`, {
  //             path: "/",
  //             domain: process.env.REACT_APP_COOKIE_DOMAIN,
  //           });
  //           window.location.href = process.env.REACT_APP_LOGIN_URL;
  //         }
  //       })();
  //     }, timeDifference); // Execute before token expires
  //   }
  // }, [cookies?.inizionavigator, token, setCookie, removeCookie]);

  //   // license key for mui data grid
  // LicenseInfo.setLicenseKey(process.env.REACT_APP_MUI_LICENSE_KEY);
  return (
    <IdleTimer ref={idleTimerRef} timeout={5 * 60 * 1000} onIdle={onIdle}>
      <ThemeProvider theme={theme}>
        <RouterProvider router={router} />
      </ThemeProvider>
    </IdleTimer>
  );
}

export default App;
